import type { ComponentType, ReactNode } from "react";
import { cn } from "@/lib/cn";

const TOM = {
  azul: "bg-brand-50 text-brand-600 dark:bg-primary/15 dark:text-primary",
  ciano: "bg-cyan-50 text-cyan-600 dark:bg-cyan-500/15 dark:text-cyan-400",
  verde: "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-400",
  ambar: "bg-amber-50 text-amber-600 dark:bg-amber-500/15 dark:text-amber-400",
} as const;

/** Cartão de uma seção da aba Dados: ícone colorido, título, subtítulo e as linhas. */
export function CartaoDados({
  icon: Icon,
  titulo,
  subtitulo,
  tom,
  className,
  children,
}: {
  icon: ComponentType<{ className?: string }>;
  titulo: string;
  subtitulo: string;
  tom: keyof typeof TOM;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section className={cn("rounded-xl border border-zinc-200 bg-white p-4 shadow-sm dark:border-border dark:bg-card sm:p-5", className)}>
      <header className="mb-3 flex items-center gap-3">
        <span className={cn("flex h-10 w-10 shrink-0 items-center justify-center rounded-lg", TOM[tom])}>
          <Icon className="h-5 w-5" />
        </span>
        <div className="min-w-0">
          <h3 className="text-[14px] font-semibold text-zinc-900 dark:text-foreground">{titulo}</h3>
          <p className="text-[12px] text-zinc-500 dark:text-muted-foreground">{subtitulo}</p>
        </div>
      </header>
      {children}
    </section>
  );
}
